class CountryRedirect extends HTMLElement {

  constructor() {
    super();

    this.popup = this;
    this.popupExpires = parseInt(this.dataset.expires);
    this.popupTestModeEnabled = typeof(this.popupExpires) === 'number' && this.popupExpires === 0;
    this.popupCookie = this.getCookie('redirect_popup');

    // if popupExpires is set to 0 (test mode), remove cookie
    if (this.popupTestModeEnabled) {
      this.removeCookie('redirect_popup');
    }

    // don't show popup when cookie is set and test mode is off
    if (this.popupCookie && this.popupCookie == 'true' && !this.popupTestModeEnabled) {
      return;
    }

    // build extreme lookup url and render popup
    if (typeof this.popup.dataset.countryRedirect !== 'undefined') {
      this.url = 'https://extreme-ip-lookup.com/json/?key=' + this.popup.dataset.countryRedirect;
      this.closeButtons = document.querySelectorAll('[data-country-redirect-close]');
      this.closeButtons.forEach(trigger =>
        trigger.addEventListener('click', this.closePopup.bind(this))
      );
      this.renderPopup();
    }
  }

  /**
   * closePopup
   * @description Close popup
   */
   closePopup () {
    this.popup.classList.add('hidden');
  }

  /**
   * openPopup
   * @description Open popup
   */
   openPopup(popupInnerContent) {
    if (!popupInnerContent) {
      return false;
    }

    this.popup.classList.remove("hidden");
    popupInnerContent.classList.remove("hidden");
  }

  /**
   * getCookie
   * @description Get cookie
   */
  getCookie(name) {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  /**
   * removeCookie
   * @description Remove cookie
   */
  removeCookie(name) {
    if (!name) return false;
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
  }

  /**
   * setCookie
   * @description Get cookie
   */
  setCookie(days) {
    if (typeof(days) !== 'number') return false;

    let maxAge = days * 60 * 60 * 24;
    if (days === 0) {
      maxAge = 0;
    }

    document.cookie = `redirect_popup=true; path=/; max-age=${ maxAge };`;
  }

  /**
   * Render popup
   * @description Render popup
   */
  renderPopup() {
    fetch(this.url)
      .then((response) => response.text())
      .then((responseText) => {

        // get ip data from ip extreme lookup
        const data = JSON.parse(responseText);
        const {countryCode, continent} = data;
        const continentHandleized = continent.replace(/\s+/g, '-').toLowerCase();

        // get language from browser
        const language = ['de', 'en'].find(lang => navigator.language.includes(lang)) || 'not-de';

        // get popup content for each type
        const popupContentCountriesArray = this.popup.querySelector('[data-country-redirect-country]')?.dataset.countryRedirectCountry?.toUpperCase().split('-');
        const popupContentCountry = popupContentCountriesArray?.includes(countryCode) ? this.popup.querySelector('[data-country-redirect-country]') : false;

        const popupContentContinent = this.popup.querySelector(`[data-country-redirect-continent="${continentHandleized}"]`) || false;
        let popupContentLanguage = this.popup.querySelector(`[data-country-redirect-language="${language}"]`) || false;

        // excluded countryCodes
        const excludedCountries = popupContentLanguage?.dataset?.excludedCountries || false;

        // check for matches with included countries. If there is no match, set popupContentLanguage to false
        if (popupContentLanguage) {
          const includedCountries = popupContentLanguage.dataset.includedCountries;

          if (includedCountries && !includedCountries.split(',').includes(countryCode)) {
            popupContentLanguage = false;
          }
        }

        // render country popup
        if (popupContentCountry !== false) {
          this.builtPopup(countryCode, popupContentCountry);

        // render continent popup
        } else if (popupContentContinent !== false) {
          this.builtPopup(continent, popupContentContinent);

        // render language popup
        } else if (popupContentLanguage !== false) {

          // don't render language popup if country is excluded
          if (excludedCountries) {
            const excludedCountriesArr = excludedCountries.split(',');
            if (excludedCountriesArr.includes(countryCode)) return;
          }

          this.builtPopup(language, popupContentLanguage);
        }

      })
      .catch(function (errors) {
        console.log("errors", errors);
      });
  }

  /**
   * Render popup title
   * @description Render popup title
   */
  renderPopupTitle(data, popup) {
    if (!data || !popup) {
      return false;
    }
    const popupTitle = popup.querySelector('[data-country-redirect-heading]') || false;
    if (popupTitle) {
      const newString = popupTitle.textContent.replace('[data]', data);
      popupTitle.textContent = newString;
    }
  }

  /**
   * builtPopup
   * @description Built popup
   */
  builtPopup(data, popup) {
    if (!data || !popup) {
      return false;
    }
    this.setCookie(this.popupExpires);
    this.renderPopupTitle(data, popup);
    this.openPopup(popup);
  }
}

if (!customElements.get('country-redirect')) {
  customElements.define('country-redirect', CountryRedirect);
}
